import React from 'react';
import styled from 'styled-components';

const StyledHeroSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  padding: 0px 150px;

  h1 {
    margin: 0 0 20px 4px;
    color: var(--cyan);
    font-family: var(--font-mono);
    font-size: clamp(14px, 5vw, 18px);
    font-weight: 400;
  }

  h2 {
    margin: 0;
    font-size: clamp(40px, 8vw, 80px);
    font-weight: 600;
    color: var(--lightest-slate);
    line-height: 1.1;
  }

  h3 {
    margin-top: 10px;
    color: var(--slate);
    line-height: 0.9;
  }

  p {
    margin: 20px 0 0;
    max-width: 500px;
  }

  .email-link {
    display: inline-block;
    margin-top: 50px;
    padding: 1.25rem 1.75rem;
    border: 1px solid var(--cyan);
    border-radius: 4px;
    color: var(--cyan);
    font-family: var(--font-mono);
    font-size: 14px;
    text-decoration: none;
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    &:hover {
      background-color: rgba(100, 255, 218, 0.1);
    }
  }
`;

const Hero = () => (
  <StyledHeroSection>
    <h1>Hi, we are</h1>
    <h2>JDLumen.ai.</h2>
    <h3>We build AI-powered solutions.</h3>
    <p>
      We are a team of AI experts, engineers, and designers dedicated to building
      intelligent software solutions that drive business growth.
    </p>
    <a href="mailto:info@jdlumen.ai" className="email-link">
      Get In Touch
    </a>
  </StyledHeroSection>
);

export default Hero;